import { Link, useNavigate } from 'react-router-dom';
import Logo from '../assets/img/logo-128.png';
import { useRef, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoading, logIn, showLoading } from '../features/general/generalSlice';
import { API_URL } from '../config/constants';
import axios from 'axios';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector(state => state.general.isLoggedIn);
  const inputRefEmail = useRef(null)
  const inputRefPassword = useRef(null)
  const [registerFields, setRegisterFields] = useState({
    email: '',
    name: '',
    password: '',
    retypePassword: ''
  });

  useState(()=>{
    console.log('isLoggedIn', isLoggedIn);
    if(isLoggedIn){
      navigate('/');
    }
  }, [isLoggedIn, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = value.trim() || '';
    setRegisterFields((prevFields) => ({
      ...prevFields,
      [name]: newValue,
    }));
  };

  const handleLogin = async (e)=> {
    e.preventDefault();
    toast.dismiss();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!registerFields.email){
      inputRefEmail.current.focus();
      toast.error('Please enter your Email ID');
      return;
    }else if(!emailPattern.test(registerFields.email)){
      inputRefEmail.current.focus();
      toast.error('Please enter valid Email ID');
      return;
    }else if(!registerFields.password){
      inputRefPassword.current.focus();
      toast.error('Please enter your Password');
      return;
    }

    try {
      setTimeout(() => {
        dispatch(showLoading());
      }, 100);
      const response = await axios.post(`${API_URL}/auth`, {
        callback: 'login',
        email: registerFields.email,
        password: registerFields.password
      }, {
        withCredentials: true  // Allows cross-origin cookies if server allows
      });
      if(response?.status === 200){
        //toast.success(`${response.data.message}`);
        setTimeout(() => {
          dispatch(logIn(response.data.user));
          navigate('/');
        }, 1000);
      }else{
        toast.error(`${response?.status}: ${response?.statusText}`);
      }
    } catch (error) {
      toast.error(`Error : ${error.response.data.message}`);
    } finally{
      setTimeout(() => {
        dispatch(hideLoading());
      }, 1000);
    }
  }

  return (
    <div className='Welcome'>
      <ToastContainer
        position='top-center'
        autoClose={5000}
      />
      <img src={Logo} alt="" />
      <h4>Login</h4>

      <form action="">
        <div className="form-group">
          <input type="text" id="email" name="email" className='form-control' placeholder="Your Email ID*" onChange={handleChange} ref={inputRefEmail} />
          <div className="text-danger"></div>
        </div>
        <div className="form-group">
          <input type="password" id="password" name="password" className='form-control' placeholder="Your Password*" onChange={handleChange} ref={inputRefPassword} />
        </div>
        <button 
          type='submit' 
          className="btn btn-site bg-site text-site-light btn-animation fw-medium mt-2"
          onClick={handleLogin}
        >Login</button>
        <div className="mt-2">
          <Link to={"/signup"} className="fw-medium text-muted">Sign up free</Link>
        </div>
      </form>

    </div>
  )
}

export default Login